import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { AnalyticService } from './core/analytic.service';
import { Observable, of, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonService } from './core/common.service';
import { RouteEventData } from './models';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  appStatus: string | null = null;
  statusMessage: string | null = null;
  showNote: boolean = false;
  destory$ = new Subject();
  navLoading$: Observable<boolean> = of(false);
  private lastLoggedBasePath: string | null = null;

  constructor(
    private readonly _commonService: CommonService,
    private readonly _titleService: Title,
    private readonly router: Router,
    private readonly _analytics: AnalyticService, 
  ) { 
    this.navLoading$ = this._commonService.isNavLoading;
  }

  ngOnInit() {
    this._commonService.applicationStatus
      .pipe(takeUntil(this.destory$))
      .subscribe(status => {
        if (status) {
          this.appStatus = status?.status;
          this.statusMessage = status?.message;
          if (status.showNote) this.showNote = status.showNote;
        }
      });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const eventData: RouteEventData = this.getNestedRouteEventData();
        this._titleService.setTitle(eventData?.screenName);

        const basePath = (event.urlAfterRedirects || '').split('?')[0];
        if (this.lastLoggedBasePath === basePath) return;
        this.lastLoggedBasePath = basePath;

        if (!eventData?.eventName) return;

        this._analytics.logAnalyticEvent(
          eventData.eventName,
          {
            'page_title': eventData.pageTitle,
            'page_path': event.urlAfterRedirects,
          });
      }
    })
  }

  ngOnDestroy() {
    this.destory$.next(null);
    this.destory$.complete();
  }

  getNestedRouteEventData(): RouteEventData {
    let currentRoute = this.router.routerState.root.firstChild;
    let eventNames: RouteEventData = { eventName: '', pageTitle: '', screenName: '' };

    while (currentRoute) {
      
      if (currentRoute?.snapshot?.data?.data) {
        eventNames = {
          eventName: currentRoute.snapshot.data.data.eventName,
          pageTitle: currentRoute.snapshot.data.data.pageTitle,
          screenName: currentRoute.snapshot.data.data.screenName,
        };
      }

      if (currentRoute?.snapshot?.routeConfig?.data?.eventName || 
        currentRoute?.snapshot?.routeConfig?.data?.pageTitle) {
        eventNames = {
          eventName: currentRoute.snapshot.routeConfig.data.eventName,
          pageTitle: currentRoute.snapshot.routeConfig.data.pageTitle,
          screenName: currentRoute.snapshot.routeConfig.data.screenName,
        };
      }
      currentRoute = currentRoute.firstChild;
    }
    return eventNames;
  }

}
